export const ACCOUNT_DELETE_CONFIRM_PHRASE = "DELETE";

export function canConfirmAccountDeletion(value) {
  return String(value || "").trim() === ACCOUNT_DELETE_CONFIRM_PHRASE;
}

export function readAccountDeletionResponse(value) {
  if (
    !value ||
    typeof value !== "object" ||
    Array.isArray(value) ||
    value.deleted !== true ||
    (value.userAction !== "hard" && value.userAction !== "soft") ||
    !Number.isSafeInteger(value.totalRows) ||
    value.totalRows < 1
  ) {
    const error = new Error("invalid_account_deletion_response");
    error.code = "invalid_account_deletion_response";
    throw error;
  }
  return Object.freeze({
    deleted: true,
    userAction: value.userAction,
    totalRows: value.totalRows,
  });
}
